/* ===== Get list data for a section ===== */
export const getListData = (s, section) => {
  return (
    s.screens?.[section.id]?.filteredList ||
    s.filteredList ||
    s.list ||
    []
  );
};

/* ===== Get meta for a section (pagination, totals) ===== */
export const getSectionMeta = (s, section) => {
  return s.screens?.[section.id] || {};
};

/* ===== Deep get by dot-path ===== */
export const getByPath = (obj, path) => {
  if (!path) return [];
  const result = path.split(".").reduce((o, k) => o?.[k], obj);
  return result ?? [];
};

/* ===== Deep set by dot-path (mutates obj) ===== */
export const setByPath = (obj, path, value) => {
  const keys = path.split(".");
  const last = keys.pop();
  let cur = obj;
  keys.forEach((k) => { cur[k] = cur[k] || {}; cur = cur[k]; });
  cur[last] = value;
};
